import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import './LandingPage.css';

const LandingPage = () => {
    const navigate = useNavigate();
    const { user } = useAuth();

    // If user is already logged in, redirect to their dashboard
    React.useEffect(() => {
        if (user) {
            navigate('/dashboard');
        }
    }, [user, navigate]);

    // Handle scrolling to section when page loads with hash
    React.useEffect(() => {
        const hash = window.location.hash;
        if (hash) {
            // Small delay to ensure the page has fully rendered
            setTimeout(() => {
                const element = document.querySelector(hash);
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    }, []);

    const testimonials = [
        {
            quote: 'The Thiagarajar Research Fellowship has been a cornerstone of my Ph.D. journey, providing the support and encouragement needed to pursue impactful research in Artificial Intelligence and Assistive Technology. It has empowered me to develop innovative solutions that promote inclusive communication and improve the lives of individuals with speech disabilities.',
            name: 'S. Betsybha Evangeline',
            role: 'AMCS Department',
        },
        {quote:'The Thiagarajar Research Fellowship enabled me to focus on quality research and publish my work in reputed journals and international conferences. I am grateful for this invaluable support.TRF provided excellent mentorship and institutional support,helping me pursue innovative research and achieve quality publications.Being a TRF scholar strengthened my research skills and enabled me to contribute to reputed journals and international conferences.',
            name:'J. Adline Vidhya',
            role:'ECE Department',
        },
        {
            quote:'The Thiagarajar Research Fellowship (TRF) provided me with valuable financial and research support, enabling me to successfully complete my Ph.D. thesis within 2.5 years by fulfilling the TRF norms and guidelines.The TRF funding enabled me to publish several research papers in reputed international conferences, which significantly enhanced my research skills, strengthened my academic profile, and contributed to my professional growth.During my TRF tenure, I gained valuable experience in laboratory assistance, teaching, and academic activities, which has been highly beneficial in my career. I sincerely thank Thiagarajar College of Engineering for this opportunity.',
            name:'R.Tharaniya',
            role:'ECE Department',
        },
        {
            quote:'The Thiagarajar Research Fellowship provided me with the mentorship, funding, and resources necessary to develop my Explainable AI framework for diabetic retinopathy diagnosis using retinal fundus images. The fellowship enabled me to publish my research in reputed journals and present my findings at international conferences. Being a TRF scholar has significantly strengthened my research capabilities and given my work real-world impact in healthcare AI.',
            name:'Ezhil',
            role:'IT Department',
        },
        {
            quote:'The Thiagarajar Research Fellowship has enabled research scholars like me to devote more focused time to high‑quality work by easing many of the practical constraints we face. While these essential needs are thoughtfully taken care of, it becomes possible to invest our best energy in meaningful research. I am grateful to Thiagarajar College of Engineering Management  and the fellowship team for their support and for sharing these research priorities.',
            name:'Mr. R.H.B.Ram murthy',
            role:'Mechanical Department',
        },
        {
            quote:'The Thiagarajar Research Fellowship (TRF) has played a major role in my research career by offering financial support, mentorship, and institutional resources that helped me maintain consistent, high-quality research work. During this fellowship, I was able to publish 10 papers. Overall, TRF has been instrumental in improving my research skills and helping me make meaningful contributions to the academic community through well-recognized publications.',
            name:'S. Mahalakshmi ',
            role:'CSBS Department',
        },
        {
            quote:'I would like to express my sincere gratitude to Thiagarajar College of Engineering for awarding me the Thiagarajar Research Fund (TRF), which provided valuable financial support throughout my doctoral research. This TRF fellowship not only offered financial assistance but also motivated me to achieve its research requirements through quality publications. As part of fulfilling the TRF fellowship objectives, I successfully published three international conference papers and two international journal papers, and I am currently working on an additional journal publication. This support encouraged me to strengthen the quality and impact of my research while successfully completing my Ph.D. I am deeply thankful to Thiagarajar College of Engineering for this prestigious initiative, which played a significant role in my academic and research journey.',
            name:'N. Sivakumar',
            role:'EEE Department',
        },
        {
            quote:'I am sincerely grateful to the Management of Thiagarajar College of Engineering for giving me the opportunity to be a Thiagarajar Research Fellow. The TRF Scheme provided me with the funding, mentorship, and research environment that enabled me to grow as a researcher.During my fellowship, I was able to publish several papers in reputed conferences and journals while advancing my research on fake news detection. The guidance and support I received through the TRF Scheme strengthened my research skills, boosted my confidence, and laid a strong foundation for my academic career.I will always be thankful to TCE and the TRF Scheme for playing a significant role in my journey from a research scholar to an Assistant Professor.',
            name:'S. Jaipreetha',
            role:'IT Department',
        },
        {
            quote:'The TRF stipend gave solid financial backing during the doctoral years. It made it possible to stay fully engaged with the research and to carry the work through to completion. I sincerely thank TCE for this support.',
            name:'Usha.N ',
            role:'EEE Department',
        },
        {
            quote:'The Thiagarajar Research Fellowship (TRF) provided invaluable financial support and a motivating research environment throughout my Ph.D. journey.It empowered me to pursue quality research with confidence, dedication, and academic excellence.I sincerely thank Thiagarajar College of Engineering for supporting my research and professional growth.',
            name:'J.Nishanthy',
            role:'EEE Department',
        },
        


        // Add more testimonials here; a new object automatically creates a new card.
    ];

    const visibleTestimonials = testimonials.filter((testimonial) => testimonial.quote && testimonial.name);

    // Slideshow state
    const [currentIndex, setCurrentIndex] = React.useState(0);
    const autoplayRef = React.useRef(null);
    const slideCount = visibleTestimonials.length;

    React.useEffect(() => {
        // autoplay every 3 seconds
        if (slideCount <= 1) return;
        stopAutoplay();
        startAutoplay();
        return () => stopAutoplay();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentIndex, slideCount]);

    const startAutoplay = () => {
        stopAutoplay();
        autoplayRef.current = setInterval(() => {
            setCurrentIndex((prev) => (prev + 1) % slideCount);
        }, 3000);
    };

    const stopAutoplay = () => {
        if (autoplayRef.current) {
            clearInterval(autoplayRef.current);
            autoplayRef.current = null;
        }
    };

    const goTo = (i) => setCurrentIndex((i + slideCount) % slideCount);
    const next = () => setCurrentIndex((prev) => (prev + 1) % slideCount);
    const prev = () => setCurrentIndex((prev) => (prev - 1 + slideCount) % slideCount);

    return (
        <div className="landing-page">
            {/* Header */}
            <header className="landing-header">
                <div>
                </div>
                <div className="header-container">
                    <div className="logo-section">
                        <img src="/lareg_logo.png" alt="TCE Logo" className="tce-logo" />
                    </div>

                    <nav className="header-nav">
                        <a href="/home" className="nav-link">Home</a>
                        <a href="#about" className="nav-link">About TRF</a>
                        <a href="#eligibility" className="nav-link">Eligibility</a>
                        <a href="#guidelines" className="nav-link">Guidelines</a>
                        <a href="#footer" className="nav-link">Contact</a>
                        <button onClick={() => navigate('/login')} className="login-btn">
                            Login
                        </button>
                    </nav>
                </div>
            </header>

            {/* Announcement Ticker */}
            <div className="announcement-ticker">
                <div className="announcement-label">
                    <span className="announcement-icon">📢</span>
                    <span>Announcement</span>
                </div>
                <div className="ticker-wrapper">
                    <div className="ticker-content">
                        Monthly Claim Report need to submit on or before 5th of every month
                    </div>
                </div>
            </div>

            {/* Hero Section */}
            <section id="home" className="hero-section">
                <div className="hero-overlay"></div>
                <div className="hero-content">
                    <h1 className="hero-title">Thiagarajar Research Fellowship</h1>
                    <p className="hero-subtitle">Empowering Excellence in Research & Innovation</p>
                    <p className="hero-description">
                        A prestigious fellowship program designed to support full-time PhD scholars at TCE
                        in their pursuit of groundbreaking research and quality publications.
                    </p>
                    <div className="hero-buttons">
                        <button onClick={() => document.getElementById('about').scrollIntoView({ behavior: 'smooth' })} className="btn-primary-large">
                            Learn More
                        </button>
                    </div>
                    <div className="hero-stats">
                        <div className="stat-item">
                            <div className="stat-number">₹25,000</div>
                            <div className="stat-label">Monthly Fellowship</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">3 Years</div>
                            <div className="stat-label">Maximum Duration</div>
                        </div>
                        <div className="stat-item">
                            <div className="stat-number">100%</div>
                            <div className="stat-label">Research Focus</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* About Section */}
            <section id="about" className="about-section">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">About TRF Program</h2>
                        <p className="section-subtitle">Supporting Research Excellence at TCE</p>
                    </div>

                    <div className="about-grid">
                        <div className="about-card">
                            <h3>Our Mission</h3>
                            <p>To increase the number of full-time research scholars and enhance the quality and quantity of research publications at Thiagarajar College of Engineering.</p>
                        </div>
                        <div className="about-card">
                            <h3>Innovation Focus</h3>
                            <p>Encouraging cutting-edge research in various engineering disciplines with emphasis on Scopus-indexed publications and high-impact journals.</p>
                        </div>
                        <div className="about-card">
                            <h3>Excellence Driven</h3>
                            <p>Supporting scholars with First Class academic credentials to achieve outstanding research outcomes and contribute to the academic community.</p>
                        </div>
                    </div>


                </div>
            </section>

            {/* Eligibility Section */}
            <section id="eligibility" className="eligibility-section">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Eligibility Criteria</h2>
                        <p className="section-subtitle">TRF Eligibility Requirements</p>
                    </div>

                    <div className="eligibility-grid">
                        <div className="eligibility-card">
                            <h4>Full-Time Scholar</h4>
                            <p>Must be a full-time research scholar at TCE admitted under Anna University, Chennai</p>
                        </div>
                        <div className="eligibility-card">
                            <h4>First Class</h4>
                            <p>Must possess First Class in either Bachelor's or Master's degree</p>
                        </div>
                        <div className="eligibility-card">
                            <h4>No Other Fellowship</h4>
                            <p>Must not be receiving any other research fellowship or financial assistance</p>
                        </div>
                    </div>

                    <div className="requirements-box">
                        <h3>Expected Research Outcomes</h3>
                        <p className="outcomes-simple">Publications in Scopus Indexed Conferences • SCImago - Q1/Q2/Q3 Journals • Anna University - CFR Journals • Patents</p>
                    </div>
                </div>
            </section>

            {/* Guidelines Section */}
            <section id="guidelines" className="guidelines-section">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Key Guidelines</h2>
                        <p className="section-subtitle">Important Rules & Regulations</p>
                    </div>

                    <div className="guidelines-grid">
                        <div className="guideline-card">
                            <div className="guideline-number">01</div>
                            <h4>Full-Time Commitment</h4>
                            <p>Scholars must devote full time to research and cannot take any part-time or full-time assignments elsewhere.</p>
                        </div>
                        <div className="guideline-card">
                            <div className="guideline-number">02</div>
                            <h4>Publication Requirements</h4>
                            <p>All publications must be in Scopus-indexed conferences or Q1/Q2/Q3 journals with proper TRF acknowledgement.</p>
                        </div>
                        <div className="guideline-card">
                            <div className="guideline-number">03</div>
                            <h4>Maximum 4 Authors</h4>
                            <p>Publications can have maximum 4 authors including scholar and supervisor, with either as corresponding author.</p>
                        </div>
                        <div className="guideline-card">
                            <div className="guideline-number">04</div>
                            <h4>Six-Month Reviews</h4>
                            <p>Progress will be monitored by review committee every six months to ensure research milestones are met.</p>
                        </div>
                        <div className="guideline-card">
                            <div className="guideline-number">05</div>
                            <h4>TRF Acknowledgement</h4>
                            <p>All publications must acknowledge TRF funding: "financially supported by Thiagarajar Research Fellowship (TRF) scheme"</p>
                        </div>
                        <div className="guideline-card">
                            <div className="guideline-number">06</div>
                            <h4>Intellectual Property</h4>
                            <p>Commercial exploitation and patent rights will be shared between the Institute, candidate, and supervisor.</p>
                        </div>
                    </div>
                </div>
            </section>

            {/* Testimonials Section */}
            <section id="testimonials" className="testimonials-section">
                <div className="container">
                    <div className="section-header">
                        <h2 className="section-title">Testimonials</h2>
                        <p className="section-subtitle">Hear from our scholars and mentors</p>
                    </div>

                    {visibleTestimonials.length > 0 ? (
                        <div className="testimonial-slider" onMouseEnter={stopAutoplay} onMouseLeave={startAutoplay}>
                            <div className="slides">
                                {visibleTestimonials.map((testimonial, index) => (
                                    <div
                                        key={index}
                                        className={`slide ${index === currentIndex ? 'active' : ''}`}
                                        aria-hidden={index === currentIndex ? 'false' : 'true'}
                                    >
                                        <div className="testimonial-card">
                                            <div className="testimonial-quote">
                                                <span className="quote-mark">“</span>
                                                {testimonial.quote}
                                            </div>
                                            <div className="testimonial-author">
                                                <div className="author-avatar">{testimonial.name.charAt(0)}</div>
                                                <div className="author-meta">
                                                    <div className="testimonial-name">{testimonial.name}</div>
                                                    <div className="testimonial-role">{testimonial.role}</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {slideCount > 1 && (
                                <>
                                    <div className="slider-controls">
                                        <button className="slider-btn prev" onClick={prev} aria-label="Previous testimonial">‹</button>
                                        <button className="slider-btn next" onClick={next} aria-label="Next testimonial">›</button>
                                    </div>
                                    <div className="slider-dots">
                                        {visibleTestimonials.map((_, i) => (
                                            <button
                                                key={i}
                                                className={`dot ${i === currentIndex ? 'active' : ''}`}
                                                onClick={() => goTo(i)}
                                                aria-label={`Go to testimonial ${i + 1}`}
                                            />
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    ) : (
                        <div className="testimonial-empty">Testimonials will appear here once they are added.</div>
                    )}
                </div>
            </section>

            {/* Footer */}
            <footer id="footer" className="landing-footer">
                <div className="footer-container">
                    <div className="footer-content">
                        <div className="footer-section">
                            <h4>Thiagarajar College of Engineering</h4>
                            <p>Madurai - 625 015, Tamil Nadu, India</p>
                        </div>
                        <div className="footer-section">
                            <h4>Contact</h4>
                            <p>Email: <a href="mailto:research@tce.edu">research@tce.edu</a></p>
                            <p>Phone: <a href="tel:+914522482240">+91 452 2482240</a></p>
                            <p>Web: <a href="https://www.tce.edu" target="_blank" rel="noopener noreferrer">www.tce.edu</a></p>
                        </div>
                        <div className="footer-section">
                            <h4>Quick Links</h4>
                            <p><a href="#home">Home</a></p>
                            <p><a href="#about">About TRF</a></p>
                            <p><a href="#eligibility">Eligibility</a></p>
                            <p><a href="#guidelines">Guidelines</a></p>
                        </div>
                    </div>
                    <div className="footer-bottom">
                        <p>Copyright © 2026 Thiagarajar College of Engineering. All Rights Reserved.</p>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default LandingPage;
